import tradePoster from "@/assets/@2x/images/trade-poster.png";
import { AhooksInfiniteScrollFrame } from "@/components/AhooksInfiniteScrollFrame";
import { Icon } from "@/components/Icon";
import { cn } from "@/libs";
import { Button, Popover, PullToRefresh, SafeArea } from "antd-mobile";
import { ListFilter } from "./components/Filter";
import { Item } from "./components/Item";
import styles from "./index.module.scss";
import { useSetup } from "./logic";
import { SellerType } from "@/constants/order/key";
export const PageTrade = () => {
  const logic = useSetup();
  const listSortOptions = logic.sorts.map(item => ({
    ...item,
    text: <div className={styles.listSortRuleItem}>{item.text}</div>,
    key: (item.key as string)
  }));
  return <div ref={logic.scollableRef} data-sentry-component="PageTrade" data-sentry-source-file="Trade.tsx">
      <PullToRefresh onRefresh={() => logic.infiniteList.reloadAsync()} data-sentry-element="PullToRefresh" data-sentry-source-file="Trade.tsx">
        <div className={styles.main}>
          <div className={styles.posterWrapper}>
            <img className={cn(styles.poster)} src={tradePoster} alt="poster" />
            <Button className={styles.posterButton} onClick={() => logic.navigate("/panic")} data-sentry-element="Button" data-sentry-source-file="Trade.tsx" />
          </div>
          <div className={styles.list}>
            <div className={styles.listHeader}>
              排序方式
              <Popover.Menu actions={listSortOptions} onAction={node => {
              logic.dispatch({
                type: "update-showSortActions",
                showSortActions: false,
                sort: (node.key as "amount:descent")
              });
            }} visible={logic.state.showSortActions} data-sentry-element="unknown" data-sentry-source-file="Trade.tsx">
                <Button fill="none" className={cn(styles.listSelectedSortRule, "flex")} onClick={() => {
                logic.dispatch({
                  type: "update-showSortActions",
                  showSortActions: !logic.state.showSortActions
                });
              }} data-sentry-element="Button" data-sentry-source-file="Trade.tsx">
                  <span style={{
                  display: "inline-block"
                }}>
                    {logic.sorts.filter(item => item.key === logic.state.sort)[0]?.text}
                  </span>
                  <Icon name={logic.state.showSortActions ? "sort" : "sort-active"} size={"16px"} data-sentry-element="Icon" data-sentry-source-file="Trade.tsx" />
                </Button>
              </Popover.Menu>
              <Button fill="none" className={styles.listFilterButton} onClick={() => {
              logic.dispatch({
                type: "update-showFilterPopup",
                showFilterPopup: true
              });
            }} data-sentry-element="Button" data-sentry-source-file="Trade.tsx">
                <Icon name="filter" size={"20px"} data-sentry-element="Icon" data-sentry-source-file="Trade.tsx" />
              </Button>
            </div>

            <AhooksInfiniteScrollFrame {...logic.infiniteList} data-sentry-element="AhooksInfiniteScrollFrame" data-sentry-source-file="Trade.tsx">
              {logic.infiniteList.data?.list.filter(item => logic.userInfo.userId !== item.sellerId).sort((a, b) => {
              switch (logic.state.sort) {
                case "amount:descent":
                  return Number(b.validAmount) - Number(a.validAmount);
                case "amount:ascent":
                  return Number(a.validAmount) - Number(b.validAmount);
                case "level:ascent":
                case "level:descent":
                  return 0;
                case "successRatio:ascent":
                  return Number(a.sellerIndicator?.totalSuccessRate) - Number(b.sellerIndicator?.totalSuccessRate);
                case "successRatio:descent":
                  return Number(b.sellerIndicator?.totalSuccessRate) - Number(a.sellerIndicator?.totalSuccessRate);
                default:
                  return 0;
              }
            }).map(item => {
              return <Item item={item} key={item.pendingOrderId} onClick={() => {
                // logic.navigate(`/buy/${item.pendingOrderId}?m=${item.sellerType ===SellerType.Merchant ?1:0}`);
                logic.navigate(`/buy/${item.pendingOrderId}?m=${item.sellerType === SellerType.Bussiness ? 1 : 0}`);
              }} />;
            })}
            </AhooksInfiniteScrollFrame>
          </div>
        </div>
        <div className={styles.whitespace}></div>
      </PullToRefresh>
      <SafeArea position="bottom" data-sentry-element="SafeArea" data-sentry-source-file="Trade.tsx" />
      <ListFilter logic={logic} visible={logic.state.showFilterPopup} onClose={() => {
      logic.dispatch({
        type: "update-showFilterPopup",
        showFilterPopup: false
      });
    }} closeOnMaskClick={true} data-sentry-element="ListFilter" data-sentry-source-file="Trade.tsx" />
    </div>;
};